module.exports = __webpack_public_path__ + "img/logo-header.1167f3b0.png";